/**
 * The documentation tab: a table of contents that follows the reading on the
 * left, the chapters on the right. A chapter link is a real URL
 * (api/graphical-requests/<chapter>), so it can be sent to a developer.
 * Code samples have one tab per client language; the choice is the same for
 * every sample and kept in this browser.
 */
define('apiDocsDocsView',[
  'module',
  'app',
  'marionette',
  'underscore',
  'jquery',
  'apiDocsContent'
], function (Module, App, Marionette, _, $, Content) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({
    className: 'api-docs-docs-view',

    template: _.template(
      '<aside class="api-docs-toc">' +
      '  <div class="api-docs-toc-title"><%- ui.onThisPage %></div>' +
      '  <ol>' +
      '    <% _.each(sections, function (s) { %>' +
      '    <li><a href="#api/graphical-requests/<%- s.id %>" class="js-toc" data-id="<%- s.id %>"><%- s.title %></a></li>' +
      '    <% }); %>' +
      '  </ol>' +
      '</aside>' +
      '<article class="api-docs-article">' +
      '  <% _.each(sections, function (s) { %>' +
      '  <section class="api-doc-section" id="api-doc-<%- s.id %>" data-id="<%- s.id %>">' +
      '    <h2><a href="#api/graphical-requests/<%- s.id %>" class="api-doc-anchor js-toc" data-id="<%- s.id %>">#</a><%- s.title %></h2>' +
      '    <%= s.html %>' +
      '  </section>' +
      '  <% }); %>' +
      '</article>'
    ),

    events: {
      'click .js-toc': 'onToc',
      'click .js-client': 'onClient',
      'click .js-copy': 'onCopy'
    },

    initialize: function (options) {
      this.content = options.content;
      this.baseUrl = options.baseUrl;
      this.section = options.section;
      this.onScroll = _.throttle(_.bind(this.spy, this), 100);
    },

    serializeData: function () {
      var ui = this.content.ui,
        baseUrl = this.baseUrl,
        client = Content.client();
      return {
        ui: ui,
        sections: _.map(this.content.sections, function (s) {
          return {id: s.id, title: s.title, html: Content.render(s.body, baseUrl, ui, client)};
        })
      };
    },

    /** Once in the page: scroll to the chapter of the URL and follow the reading. */
    onAttach: function () {
      // The dashboard scrolls inside its content container, not the window:
      // listen to every scroll (capture), whichever element scrolls.
      document.addEventListener('scroll', this.onScroll, true);
      this.listening = true;
      if (this.section) {
        _.defer(_.bind(this.scrollTo, this, this.section, true));
      } else {
        this.spy();
      }
    },

    scrollTo: function (id, instant) {
      var target = this.$('#api-doc-' + id)[0],
        scroller = this.$el.closest('.api-docs-page-view')[0];
      if (target && target.scrollIntoView) {
        // The page scrolls smoothly (CSS), which would also animate the jump on load.
        if (instant && scroller) {
          scroller.style.scrollBehavior = 'auto';
        }
        target.scrollIntoView({behavior: instant ? 'auto' : 'smooth', block: 'start'});
        if (instant && scroller) {
          scroller.style.scrollBehavior = '';
        }
      }
      this.highlight(id);
    },

    onToc: function (e) {
      e.preventDefault();
      var id = $(e.currentTarget).data('id');
      App.navigate('api/graphical-requests/' + id, {trigger: false});
      this.scrollTo(id);
    },

    /** The chapter at the top of the reading area is the current one. */
    spy: function () {
      var current = null,
        limit = 140;
      this.$('.api-doc-section').each(function () {
        if (this.getBoundingClientRect().top <= limit) {
          current = $(this).data('id');
        }
      });
      this.highlight(current || (this.content.sections[0] && this.content.sections[0].id));
    },

    highlight: function (id) {
      this.$('.api-docs-toc a').removeClass('on');
      this.$('.api-docs-toc a[data-id="' + id + '"]').addClass('on');
    },

    onClient: function (e) {
      var id = $(e.currentTarget).data('client');
      Content.setClient(id);
      // Every sample switches, those without this client keep theirs.
      this.$('.api-doc-code').each(function () {
        var $code = $(this);
        if (!$code.find('.api-doc-code-pane[data-client="' + id + '"]').length) {
          return;
        }
        $code.find('.js-client').removeClass('on').filter('[data-client="' + id + '"]').addClass('on');
        $code.find('.api-doc-code-pane').hide().filter('[data-client="' + id + '"]').show();
      });
    },

    onCopy: function (e) {
      var $button = $(e.currentTarget),
        $code = $button.closest('.api-doc-code'),
        $pane = $code.find('pre:visible').first();
      Content.copy($pane.text(), $button, this.content.ui);
    },

    onDestroy: function () {
      if (this.listening) {
        document.removeEventListener('scroll', this.onScroll, true);
      }
    }
  });
});

